<div class="row align-items-center my-3 px-3">
  <div class="col-6">
    <h2 class="m-2 d-flex align-items-center gap-2 fw-bold">
      {{ text }} <shared-ui-badges-badge *ngIf="badgeText && badgeType" [type]="badgeType" [text]="badgeText"></shared-ui-badges-badge>
    </h2>
  </div>
  <div class="col-6 d-flex justify-content-end align-items-center">
    <ng-content></ng-content>
  </div>
</div>
